export type QrSocketMessage =
  | { type: 'noop' }
  | { type: 'scanned' }
  | { type: 'expired' }
  | { type: 'user'; userId: string }

export type QrLoginUrlInput = {
  host: string
  newhost: string
  suffix: string
  languageCode: string
  countryCode: string
  token: string
  type: string
}

export const buildQrLoginUrl = (input: QrLoginUrlInput) => {
  const baseUrl = `https://m.${input.newhost}.${input.suffix}/download.html`
  const params = new URLSearchParams({
    languageCode: input.languageCode,
    countryCode: input.countryCode,
    qrid: input.token,
    type: input.type,
    app: 'usersite',
  })

  return `${baseUrl}?${params.toString()}`
}

export const parseQrSocketMessage = (data: unknown): QrSocketMessage => {
  if (data === '1' || data === 1) return { type: 'scanned' }
  if (data === '2' || data === 2) return { type: 'expired' }

  const userId = typeof data === 'string' || typeof data === 'number' ? String(data).trim() : ''
  if (!userId) return { type: 'noop' }

  return { type: 'user', userId }
}

export const buildQrUserPayload = (input: { countryCode: string; languageCode: string; userId: string }) => ({
  ApplicationType: 7,
  CountryCode: input.countryCode,
  LanguageCode: input.languageCode,
  userId: input.userId,
  WebLogin: true,
})
